import dayjs from 'dayjs'
import { DatasetFile, DatasetFileStatus } from '~/api/onPremAgent/datasetsAPI'
import Table from '~/components/Table'
import TextWithOverflow from '~/components/TextWithOverflow'
import { renderStatusPill } from '~/utils/statusPill'
import cs from './dataset_page.scss'

const renderFileName = (row: DatasetFile) => {
  const fileName = row.file_path.split('/').pop() || ''
  return fileName
}

const DATASET_FILE_STATUS_CONFIG = {
  // If the dataset is stuck here, it might mean there is a connection issue to the cloud.
  ready: { type: 'warning' },
  uploading: { type: 'accent' },
  uploaded: { type: 'success' },
  upload_failed: { type: 'error' },
}

const renderUploadStatus = (status: DatasetFileStatus) => {
  return renderStatusPill(status, DATASET_FILE_STATUS_CONFIG, {})
}

const renderLastUploadedTime = (timestamp: string) => {
  const time = dayjs(timestamp)
  return <div className={cs.time}>{time.fromNow()}</div>
}

const tableColumns = [
  {
    name: 'File Name',
    width: 350,
    render: renderFileName,
    oneLine: true,
    smallText: true,
  },
  {
    name: 'File Type',
    width: 150,
    render: (row: DatasetFile) => row.file_type,
    smallText: true,
  },
  {
    name: 'File Location',
    width: 200,
    render: (row: DatasetFile) => (
      <TextWithOverflow text={row.file_path} popoverContent={row.file_path} />
    ),
    oneLine: true,
    smallText: true,
  },
  {
    name: 'Upload Status',
    width: 150,
    render: (row: DatasetFile) => renderUploadStatus(row.status),
    verticalCenter: true,
  },
  {
    name: 'Last Updated',
    width: 150,
    render: (row: DatasetFile) => renderLastUploadedTime(row.updated_at),
    rightAlign: true,
    smallText: true,
  },
]
export default function DatasetFilesTable({
  datasetFiles,
}: {
  datasetFiles: DatasetFile[]
}) {
  return (
    <Table<DatasetFile>
      columns={tableColumns}
      data={datasetFiles}
      rowKey='uuid'
      rowLeftRightPaddingVariant='rowPaddingNormal'
      headerTopBottomPaddingVariant='headerTopBottomPaddingEqual'
      heightSizing='default'
      stickyHeaders
    />
  )
}
